// Helpers compartilhados entre views
export const BRL = (v) => 'R$ ' + Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const NUM = (v) => Number(v || 0).toLocaleString('pt-BR');
export const QTY = (v) => Number(v || 0).toLocaleString('pt-BR', { maximumFractionDigits: 3 });
export const DATE = (s) => s ? new Date(s).toLocaleDateString('pt-BR') : '—';
export const DT = (s) => s ? new Date(s).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }) : '—';
export const SHORT = (s, n) => s ? (s.length > n ? s.slice(0, n) + '…' : s) : '';
export const escapeHTML = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
export const sleep = (ms) => new Promise(r => setTimeout(r, ms));
